import { render, staticRenderFns } from "./employeeLabel.vue?vue&type=template&id=5eb05db9&scoped=true&"
import script from "./employeeLabel.vue?vue&type=script&lang=js&"
export * from "./employeeLabel.vue?vue&type=script&lang=js&"
import style0 from "./employeeLabel.vue?vue&type=style&index=0&id=5eb05db9&lang=less&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eb05db9",
  null
  
)

export default component.exports